
export const Register = (function() {
  var idSuccess = false;
  var emailSuccess = false;
  var phoneSuccess = true;
  var passwordSuccess = false;
  var privateKeySuccess = false;
  var agreeTerms = true;
  var emailMatch = false;
  var phoneMatch = true;
  var btn;
  var successMydexId;
  

  var init = function () {
    btn = document.getElementById("myds-register-submit");

    //checks if mydexid already exists
    $('#mydexid').on('blur', function () {
  
      var mydexid = $('#mydexid').val();
      if(successMydexId == mydexid){
        //no need to re-check, already valid
        idSuccess = true;
        return false;
      }
  
      if (mydexid) {
        var url_check_id = '/check-mydexid';
        var csrf = Util.getCSRF();
  
        $.ajax({
          url: url_check_id,
          type: 'post',
          data: {
            'mydexid': mydexid
          },
          headers: {
            'x-csrf-token': csrf
          }
        }).done(function (response) {
  
          if (response.success === 0) {
            showError("mydexid", response.message);
            idSuccess = false;
          } else {
            document.getElementById("message").classList.add("d-none");
            idSuccess = true;
            successMydexId = mydexid;
          }
          canRegister();
        });
      }
    });

    //checks if email address already exists
    $('#input-email').on('blur', function () {
      var input_email = $('#input-email').val();
  
      if (input_email) {
        var url_check_email = '/check-email';
        var csrf = Util.getCSRF();
  
        $.ajax({
          url: url_check_email,
          type: 'post',
          data: {
            'email': input_email
          },
          headers: {
            'x-csrf-token': csrf
          }
        }).done(function (response) {
          if (response.success === 0) {
            showError("input-email", response.message);
            emailSuccess = false;
          } else {
            emailSuccess = true;
            //removes error message
            document.getElementById("message").classList.add("d-none");
            //directs user to confirm email
            document.getElementById("confirm-email").focus();
            checkEmailsMatch();
          }
  
        });
        if (emailSuccess) {
          document.getElementById("message").classList.add("d-none");
        }
      }
      else if(idSuccess) { //dont focus people on the email field and show a message, if the mydexid hasnt been passed, its got its own validation
        btn.disabled = true;
        showError("input-email", "Please enter a valid email address");
        document.getElementById("email-match").classList.add("d-none");
        emailSuccess = false;
      }
    });

    $("#confirm-email").on('input', function () {
      checkEmailsMatch();
    });

    //checks if phone number already exists
    $('#input-phone').on('blur', function () {
      var input_phone = $('#input-phone').val();

      if (input_phone) {
        var url_check_phone = '/check-phone';
        var csrf = Util.getCSRF();

        $.ajax({
          url: url_check_phone,
          type: 'post',
          data: {
            'phone': input_phone
          },
          headers: {
            'x-csrf-token': csrf
          }
        }).done(function (response) {
          if (response.success === 0) {
            showError("input-phone", response.message);
            phoneSuccess = false;
            btn.disabled = true;
          } else {
            phoneSuccess = true;
            //removes error message
            document.getElementById("message").classList.add("d-none");
            //directs user to confirm phone
            document.getElementById("confirm-phone").focus();
            checkPhonesMatch();
          }
        });
        if (phoneSuccess) {
          document.getElementById("message").classList.add("d-none");
        }
      } else {
        // Was phone field emptied? Check this matches the confirm field
        checkPhonesMatch();
      }
    });
  
    $("#confirm-phone").on('input', function () {
      checkPhonesMatch();
    });

    ////what happens when a user navigates out of password input field////
    $('#input-password').on('blur', function () {
      var password = $('#input-password').val();
      passwordSuccess = false;
  
      if (password) {
        //checks if password is at least 8 characters long (also accounts for an empty field)
        if (password.length < 8) {
          showError("input-password", "Password must be at least 8 characters long");
          document.getElementById("password-match").classList.add("d-none");
          canRegister();
        } else {
          //otherwise, checks if password is the same as the private key
          if (valuesAreNotUnique(password, 'private-key')) {
            showError("input-password", "Password and Private Key cannot be the same");
          } else if (valuesAreNotUnique(password, 'mydexid')) {
            showError("input-password", "Password and UniqueID cannot be the same");
          } else {
            //if they are different, checks if the passwords match
            document.getElementById("message").classList.add("d-none");
            checkPasswordsMatch();
          }
        }
      } else {
        canRegister();
      }
    });
    $("#confirm-password").on('input', function () {
      checkPasswordsMatch();
    });

    ////what happens when a user navigates out of private-key input field////
    $("#private-key").on('blur', function () {
      var privateKey = $('#private-key').val();
      privateKeySuccess = false;
  
      if (privateKey) {
        //checks that private key is |.| 8 and 128 characters long (inclusive) - this also accounts for an empty field
        if (privateKey.length < 8 || privateKey.length > 128) {
          showError("private-key", "Private Key must be between 8 and 128 characters long");
        } else {
          //checks if the password is the same as the private key
          if (valuesAreNotUnique(privateKey, 'input-password')) {
            showError("private-key", "Private Key and Password cannot be the same");
          } else if (valuesAreNotUnique(privateKey, 'mydexid')) {
            showError("private-key", "Private Key and UniqueID cannot be the same");
          } else {
            //if they are different, checks that the two private key fields match
            document.getElementById("message").classList.add("d-none");
            checkPrivateKeysMatch();
          }
        }
      } else {
        canRegister();
      }
    });
  
    $("#confirm-private-key").on('input', function () {
      checkPrivateKeysMatch();
    });

    //deals with showing/hiding PASSWORD in password fields
    $(".password-toggle a").on('click', function (event) {
      event.preventDefault();
      var inputPassword = $('#input-password').val();
  
      // If current password is being toggled only allow that input box to be shown
      if ($(this).hasClass("password-eye")) {
        // toggleClass will swap these two classes if the other one is present, this is what adds the slash through the eye
        $('.eye').toggleClass('fa-eye-slash fa-eye');
        inputPassword = $('.password input')
        changeTypeInput(inputPassword);
  
      } else {
        // Toggles both new password and confirm password inputs as both have the new-confirm-password class
        $('.eye-confirm').toggleClass('fa-eye-slash fa-eye');
        inputPassword = $('.password-confirm input')
        changeTypeInput(inputPassword);
  
      }
    });
  
    //deals with showing/hiding PRIVATE KEY in private key fields
    $(".private-key-toggle a").on('click', function (event) {
      event.preventDefault();
      var inputPrivateKey = $('#private-key').val();
  
      if ($(this).hasClass("private-key-eye")) {
        $('.pk-eye').toggleClass('fa-eye-slash fa-eye');
        inputPrivateKey = $('.private-key input')
        changeTypeInput(inputPrivateKey);
  
      } else {
        $('.eye-confirm-pk').toggleClass('fa-eye-slash fa-eye');
        inputPrivateKey = $('.private-key-confirm input')
        changeTypeInput(inputPrivateKey);
  
      }
    });

    $("#agree-terms").on('click', function () {
      if (document.getElementById("agree-terms").checked) {
        agreeTerms = true;
      } else {
        agreeTerms = false;
      }
      canRegister();
    });

    $('#create_form').on('submit', function () {
      btn.disabled = true;
      btn.textContent = "Registering";
    });

  }

  var checkEmailsMatch = function () {
    var email = $('#input-email').val();
    var confirmEmail = $('#confirm-email').val();
    document.getElementById("email-match").classList.remove("d-none");

    if (email === confirmEmail) {
      showSuccessConfirmed("email", "Emails");
      emailMatch = true;
    } else {
      showErrorConfirmed("email", "Emails");
      emailMatch = false;
    }
    canRegister();
  }
  var checkPhonesMatch = function () {
    var phone = $('#input-phone').val();
    var confirmPhone = $('#confirm-phone').val();
    document.getElementById("phone-match").classList.remove("d-none");

    if (phone === confirmPhone) {
      showSuccessConfirmed("phone", "Phone numbers");
      phoneMatch = true;
    } else {
      showErrorConfirmed("phone", "Phone numbers");
      phoneMatch = false;
    }
    canRegister();
  }
  var checkPasswordsMatch = function () {
    var password = $('#input-password').val();
    var confirmPassword = $('#confirm-password').val();

    document.getElementById("password-match").classList.remove("d-none");

    if (password === confirmPassword) {
      showSuccessConfirmed("password", "Passwords");
      passwordSuccess = true;
    } else {
      showErrorConfirmed("password", "Passwords");
      passwordSuccess = false;
    }
    canRegister();
  }
  var checkPrivateKeysMatch = function () {
    var private_key = $('#private-key').val();
    var confirmPrivateKey = $('#confirm-private-key').val();

    document.getElementById("private-key-match").classList.remove("d-none");

    if (private_key === confirmPrivateKey) {
      showSuccessConfirmed("private-key", "Private Keys");
      privateKeySuccess = true;
    } else {
      showErrorConfirmed("private-key", "Private Keys");
      privateKeySuccess = false;
    }
    canRegister();
  }
  // checks if two values passed are unique
  var valuesAreNotUnique = function (inputValue, valueToCheckAgainst) {
    var valueToCheck = $(`#${valueToCheckAgainst}`).val();
    //only check if there are some values to check against
    if (inputValue || valueToCheck) {
      if (inputValue === valueToCheck) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  // removes css class to display error message
  var showError = function(idElement, errorMessage) {
    document.getElementById(idElement).focus();
    document.getElementById("message").classList.remove("d-none");
    document.getElementById("error-message").innerHTML = errorMessage;
  }
  // display success message on confirmed password/private key/email
  var showSuccessConfirmed = function(element, message) {
    document.getElementById(element + "-match").classList.remove("text-danger");
    document.getElementById(element + "-match").classList.add("text-success");
    document.getElementById(element + "-match").innerHTML = message + " match.";
  }
  // displays error message on confirmed password/private key/email
  var showErrorConfirmed = function(element, errorMessage) {
    document.getElementById(element + "-match").classList.add("text-danger");
    document.getElementById(element + "-match").classList.remove("text-success");
    document.getElementById(element + "-match").innerHTML = errorMessage + " don't match.";
  }
  //helper function to change input type for password / private key
  var changeTypeInput = function (input) {
    if (input.attr('type') === 'password') {
      input.attr('type', 'text');
    } else {
      input.attr('type', 'password');
    }
  }
  //checks that all fields have been succesfully input and enables register button
  var canRegister = function () {
      if (!idSuccess) {
        document.getElementById("mydexid").focus();
      }

      if (idSuccess && passwordSuccess && privateKeySuccess && agreeTerms) {
        if (emailSuccess && emailMatch && phoneSuccess && phoneMatch) {
          document.getElementById("message").classList.add("d-none");
          btn.removeAttribute('disabled');
        }
        if (!emailSuccess) {
          showError("input-email", "The email address is unavailable.");
          btn.disabled = true;
        }
        if (!emailMatch) {
          showError("confirm-email", "Please make sure you have entered and confirmed your email address");
          btn.disabled = true;
        }
        if (!phoneSuccess) {
          showError("input-phone", "The phone number is unavailable.");
          btn.disabled = true;
        }
        if (!phoneMatch) {
          showError("confirm-phone", "Please make sure you have entered and confirmed your phone number");
          btn.disabled = true;
        }
      } else {
        btn.disabled = true;
      }
  }
  
  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });

  return {
    init: init,
    idSuccess: idSuccess,
    emailSuccess: emailSuccess,
    phoneSuccess: phoneSuccess,
    passwordSuccess: passwordSuccess,
    privateKeySuccess: privateKeySuccess,
    agreeTerms: agreeTerms,
    emailMatch: emailMatch,
    phoneMatch: phoneMatch,
    btn: btn,
    checkEmailsMatch: checkEmailsMatch,
    checkPhonesMatch: checkPhonesMatch,
    checkPasswordsMatch: checkPasswordsMatch,
    checkPrivateKeysMatch: checkPrivateKeysMatch,
    valuesAreNotUnique: valuesAreNotUnique,
    showError: showError,
    showErrorConfirmed: showErrorConfirmed,
    showSuccessConfirmed: showSuccessConfirmed,
    changeTypeInput: changeTypeInput,
    canRegister: canRegister
  }

}());
